import { render, staticRenderFns } from "./app.signup.vue?vue&type=template&id=5619fec6&"
import script from "./app.signup.vue?vue&type=script&lang=js&"
export * from "./app.signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports